module.exports = __webpack_public_path__ + "static/media/deactivate.84d4edf0.svg";